import { useAuthorizationServiceV1 } from "@rw1/api-services";
import { Authorization_V1 } from "@rw1/auto-generated-clients";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { STALE_TIME_MS } from "./constants";
import { QueryKeys } from "./QueryKeys";

interface UseUserRolesResult {
    userRoles: Authorization_V1.UserRole[] | undefined;
    isLoading: boolean;
    error: Error | null;
}

export const useUserRoles = (userId?: string): UseUserRolesResult => {
    const authorizationServiceV1 = useAuthorizationServiceV1();

    const {
        data: userRoles,
        isLoading,
        error,
    } = useQuery<Authorization_V1.UserRole[]>({
        queryKey: [QueryKeys.UserRoles, userId],
        queryFn: () => {
            if (!userId) throw new Error("User ID is required");

            return authorizationServiceV1.getUserRoles(userId);
        },
        enabled: !!userId,
        staleTime: STALE_TIME_MS,
        retry: false,
    });

    return useMemo(() => {
        return {
            userRoles,
            isLoading: isLoading || (!!userId && userRoles === undefined && !error),
            error: error ?? null,
        };
    }, [userRoles, isLoading, error, userId]);
};